import { useModelsSummaryByAssetQuery } from 'queries/models';
import Status, { statusTypes } from './Status';
import { useTranslation } from 'react-i18next';
import { AlarmingProps } from './types';
import { getStatusCount } from 'components/StatusSummary/helper';
import { useMemo } from 'react';

const statusKey = 'status';

export const ModelsAlarming = ({ asset }: AlarmingProps) => {
  const { t } = useTranslation();
  const { data } = useModelsSummaryByAssetQuery({ assetId: asset?.id });

  const { ALARMING = 0 } = useMemo(
    () => getStatusCount(statusKey, data?.models ?? []),
    [statusKey, data],
  );

  const HAS_ALARMS = ALARMING > 0;

  return (
    <div>
      <Status status={HAS_ALARMS ? statusTypes.error : statusTypes.offline} />
      <span>
        {ALARMING} {t('components:status_indicators.models_alarming')}
      </span>
    </div>
  );
};
